<template>
  <v-container fluid>
    <material-card
      :heading="heading"
      icon-small
      icon="mdi-help"
      :title="heading"
      color="primary"
    >
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
        />
      </v-card-text>
    </material-card>
  </v-container>
</template>
<script>
  import { get } from 'vuex-pathify'

  export default {

    data: () => ({
      heading: '',
      meetings: [],
      loading: false,
      options: {
        sortDesc: true,
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { sortable: false, text: '건물', value: 'buildingName', align: 'center', class: 'primary--text' },
        { sortable: false, text: '타입', value: 'name', align: 'center', class: 'primary--text' },
        { sortable: false, text: '연락처', value: 'contact', align: 'center', class: 'primary--text' },
        { sortable: false, text: '설명', value: 'description', align: 'center', class: 'primary--text' },
      ],
      items: [],
    }),

    computed: {
      info: get('user/info'),
    },

    created () {
      this.heading = this.$t('page.help-desk')
    },

    mounted () {
      this.getHelpDeskInfo()
    },

    methods: {
      async getHelpDeskInfo () {
        await this.$http.get('/api/v1/types').then(response => {
          this.items = response.data
        }).catch(err => {
          console.log(err)
        })
      },
    },
  }
</script>

<style scoped>

</style>
